import { csx } from '@vtex/admin-ui'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import type { CheckoutButtonProps } from '../../../../components'
import { CheckoutButton } from '../../../../components'

export type ContinueButtonProps = CheckoutButtonProps

export const ContinueButton = (props: ContinueButtonProps) => (
  <CheckoutButton
    size="large"
    className={csx({
      width: '100%',
    })}
    {...props}
  >
    <FormattedMessage id="continue" />
  </CheckoutButton>
)
